module.exports = __webpack_public_path__ + "img/chart-01.072893ae.png";